import { attendanceMatrixSchema } from "../../schemas/training";
import { fetchApi } from "../internal";

type AttendanceParams = {
	from: string;
	to: string;
};

function attendanceQuery(params: AttendanceParams): string {
	const searchParams = new URLSearchParams();
	searchParams.set("from", params.from);
	searchParams.set("to", params.to);
	return `?${searchParams.toString()}`;
}

// The players × next-N-sessions attendance grid behind /training/{id}. One
// aggregate read in place of one round-trip per session.
export const attendance = {
	get: (clubId: string, params: AttendanceParams) =>
		fetchApi(`/clubs/${clubId}/attendance${attendanceQuery(params)}`, attendanceMatrixSchema),
};
